/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css2?family=Muli:ital,wght@0,400;0[_ngcontent-%COMP%], 500[_ngcontent-%COMP%];0[_ngcontent-%COMP%], 700[_ngcontent-%COMP%];1[_ngcontent-%COMP%], 400&display=swap)[_ngcontent-%COMP%];.wrapper[_ngcontent-%COMP%]{width:160px;display:flex;align-items:center}.text[_ngcontent-%COMP%]{margin-right:12px;color:#9da2bd;font-size:12px;line-height:150%;font-weight:300}"];
export { styles as styles };
